import { goTo, loginPath } from '@lingoda/router';
import { LeadConversionFlowFrame } from '@lingoda/lead-conversion-flow';
import { EmailVerificationFrame } from '@lingoda/email-verification';
import { usePrivateFramePreloadQuery } from '@lingoda/graphql';
import { useTimezoneCheck } from '@lingoda/timezone';
import { ensureAuthenticated, useEnsureOnboardedAndSetUp } from '@lingoda/student-auth';
import { KameleoonProvider } from '@lingoda/kameleoon';
import { useDialogsTriggers } from '@lingoda/student-frontend/hooks';
import { PrivateDialogsTrigger } from '@lingoda/student-frontend/dialogs';
import { AccessBlock } from './AccessBlock';
import { UserBlock } from './UserBlock';
import { MatomoBlock } from './FeatureFlagsBlock';
import { EventSourceListener } from './EventSourceListener';
import { PrivatePageFrameWrapper } from './PrivatePageFrameWrapper';

const Redirect = () => {
    goTo(loginPath());

    return null;
};

export const PrivatePageFrame = ensureAuthenticated(
    ({ children, ...props }) => {
        usePrivateFramePreloadQuery();
        useDialogsTriggers();
        useTimezoneCheck();
        useEnsureOnboardedAndSetUp();

        return (
            <PrivatePageFrameWrapper {...props}>
                <UserBlock>
                    <KameleoonProvider>
                        <MatomoBlock>
                            <EmailVerificationFrame>
                                <LeadConversionFlowFrame>
                                    <AccessBlock>
                                        <EventSourceListener>{children}</EventSourceListener>
                                    </AccessBlock>
                                </LeadConversionFlowFrame>
                                <PrivateDialogsTrigger />
                            </EmailVerificationFrame>
                        </MatomoBlock>
                    </KameleoonProvider>
                </UserBlock>
            </PrivatePageFrameWrapper>
        );
    },
    { Redirect },
);
